import { useEffect } from "react";

import { GqlJob, GqlJobState } from "~/__generated__";

import useCommonJobQueueGetJobById from "../api/useCommonJobStatusGetById";

type Props = {
    worker: string;
    jobId: string | undefined;
    onFinished?: (job: GqlJob) => void;
    refetchData?: () => void;
    skip?: boolean;
};

export enum WorkerJobState {
    active = "active",
    finished = "finished",
    error = "error",
}

export default function useWorkerJobStatusMonitor({ worker, jobId, onFinished, refetchData, skip }: Props) {
    const jobId_ = skip === true ? undefined : jobId;
    const { data, startPolling, stopPolling } = useCommonJobQueueGetJobById(jobId_, worker);

    const isJobActive = data
        ? [GqlJobState.Active, GqlJobState.Created, GqlJobState.Retry].includes(data?.status)
        : false;

    const status: WorkerJobState = isJobActive
        ? WorkerJobState.active
        : data?.status === GqlJobState.Completed
          ? WorkerJobState.finished
          : WorkerJobState.error;

    useEffect(() => {
        if (isJobActive) {
            startPolling(1000);
        } else {
            stopPolling();
        }
    }, [isJobActive, startPolling, stopPolling]);

    useEffect(() => {
        if (data?.status === GqlJobState.Completed) {
            onFinished?.(data);
        }
    }, [onFinished, data]);

    useEffect(() => {
        if (status === WorkerJobState.finished && data?.output?.type !== "failed") {
            refetchData?.();
        }
    }, [status, data, refetchData]);

    return { status, data };
}
